import type { MembershipProduct, SpaceProfile } from "../SpaceType";
import { SpaceHomeMembershipSection } from "../components/SpaceHomeMembershipSection";

export function SpaceHomeMembershipListItem(props: {
  spaceId: string;
  row: MembershipProduct;
  isLoggedIn: boolean;
  onLoginRequest: () => void;
  spaceProfile: SpaceProfile | null;
  onSubscribePrimaryClick?: () => void;
}): JSX.Element {
  const {
    spaceId,
    row,
    isLoggedIn,
    onLoginRequest,
    spaceProfile,
    onSubscribePrimaryClick,
  } = props;
  const isBundle = row.productKind === "product_bundle";
  return (
    <li
      className={
        isBundle
          ? "space-membership-item space-membership-item--bundle"
          : "space-membership-item"
      }
    >
      <div className="space-m-body">
        <div className="space-m-main">
          <div className="space-m-title-row">
            <div className="space-membership-name">{row.displayName}</div>
            <SpaceHomeMembershipSection
              spaceId={spaceId}
              row={row}
              isLoggedIn={isLoggedIn}
              onLoginRequest={onLoginRequest}
              spaceProfile={spaceProfile}
              onSubscribePrimaryClick={onSubscribePrimaryClick}
              part="meta"
            />
          </div>
          <div className="space-m-content-row">
            {row.description?.trim() ? (
              <p className="space-membership-intro">{row.description.trim()}</p>
            ) : null}
            <SpaceHomeMembershipSection
              spaceId={spaceId}
              row={row}
              isLoggedIn={isLoggedIn}
              onLoginRequest={onLoginRequest}
              spaceProfile={spaceProfile}
              onSubscribePrimaryClick={onSubscribePrimaryClick}
              part="action"
            />
          </div>
        </div>
      </div>
    </li>
  );
}
